'use client';

import {
  type ActivateResponse,
  momoActivateFn,
  type MomoActivatePayload,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export interface ActivateRequestBody {
  activation_code: string;
  ahamove_sms_auth: boolean;
  country_code: string;
  fcm: boolean;
  imei: string;
  mobile: string;
  type: string;
}

export const useMomoActivateUserMutation = (
  opts?: UseMutationOptions<
    ActivateResponse,
    DefaultQueryError,
    MomoActivatePayload
  >
) =>
  useMutation<ActivateResponse, DefaultQueryError, MomoActivatePayload>({
    mutationFn: momoActivateFn,
    ...opts,
  });
